// This files provides compatibility without tree platform.
import { WebView } from 'react-native';
export { WebView };
export default WebView;
